import React from 'react';

import { useGetCurrentDate } from '@swf/poker';

type DateOptions = Intl.DateTimeFormatOptions & {
  showTime?: boolean;
  showDate?: boolean;
  isRelative?: boolean;
};

interface Props {
  utcDate: string;
  options?: DateOptions;
}

const defaults: DateOptions = {
  showDate: true,
  showTime: true,
  isRelative: false
};

const FormattedUTCDate: React.FC<Props> = ({ utcDate, options = defaults }) => {
  const { showDate, showTime, isRelative, ...rest } = { ...defaults, ...options };
  const date = new Date(`${utcDate} UTC`.replace(/-/g, '/'));
  const { timeZoneName } = useGetCurrentDate(date, isRelative);
  const { locale } = Intl.DateTimeFormat().resolvedOptions();
  const timeOptions = { timeZone: timeZoneName, ...rest };

  return (
    <>{Intl.DateTimeFormat(locale, { ...timeOptions, timeZone: timeZoneName }).format(date)}</>
  );
};

export default FormattedUTCDate;
